// https://github.com/webpack/webpack/issues/6461
module.exports = (() => {
  try {
    return window
  } catch {
    return {}
  }
})()
